import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.15_@babel+core@7.24.7_@playwright+test@1.54.2_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.15_@babel+core@7.24.7_@playwright+test@1.54.2_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/layers/presentation/components/blog/SocialShare.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/layers/presentation/components/blog/TableOfContents.tsx");
